import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UserRolesAndPermissionsService } from '@core/services/user-roles-and-permissions.service';
import {
  DvSplitterEventsService,
  DvSplitterResizableSide,
} from '@devinco/ui/dds/splitter';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { Observable } from 'rxjs';

@Component({
  templateUrl: './users-page.component.html',
  styleUrls: ['../../styles/page.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UsersPageComponent implements OnInit {
  private splitterEvents = inject(DvSplitterEventsService);
  private permissionsService = inject(UserRolesAndPermissionsService);

  resizableSide: typeof DvSplitterResizableSide = DvSplitterResizableSide;
  canAddUser$: Observable<boolean>;

  ngOnInit(): void {
    this.canAddUser$ = this.permissionsService.hasPermissions([
      RolesAndPermissions.UserEdit,
    ]);
  }

  onCreateClick(): void {
    this.splitterEvents.isSplitterOpened$.next(true);
  }
}
